module.exports = __webpack_public_path__ + "assets/img/card.60464cc9.png";